import FleetView from '../FleetView.vue'
import ExpenseList from '../Pages/ExpenseList.vue'
import ExpenseEditor from '../Pages/ExpenseEditor.vue'
import WashStatus from '../Pages/WashStatus.vue'
import WashList from '../Pages/WashList.vue'
import WashEditor from '../Pages/WashEditor.vue'
import MaintenanceStatus from '../Pages/MaintenanceStatus.vue'
import MaintenanceList from '../Pages/MaintenanceList.vue'
import MaintenanceEditor from '../Pages/MaintenanceEditor.vue'
import MaintenanceConfig from '../Pages/MaintenanceConfig.vue'
import RentalStatus from '../Pages/RentalStatus.vue'
import RentalPaymentList from '../Pages/RentalPaymentList.vue'
import RentalPaymentEditor from '../Pages/RentalPaymentEditor.vue'

const routes = [
  {
    path: '/fleet',
    component: FleetView,
    name: 'fleet',
    children: [
      // Gastos (DEF-ADM-015).
      {
        path: 'expenses',
        name: 'fleet-expenses',
        component: ExpenseList
      },
      {
        path: 'expenses/create',
        name: 'fleet-expense-create',
        component: ExpenseEditor
      },
      {
        path: 'expenses/:id/edit',
        name: 'fleet-expense-edit',
        component: ExpenseEditor
      },
      // Lavados (DEF-ADM-015 Fase 2).
      {
        path: 'washes',
        name: 'fleet-washes',
        component: WashStatus
      },
      {
        path: 'washes/history',
        name: 'fleet-wash-list',
        component: WashList
      },
      {
        path: 'washes/create',
        name: 'fleet-wash-create',
        component: WashEditor
      },
      {
        path: 'washes/:id/edit',
        name: 'fleet-wash-edit',
        component: WashEditor
      },
      // Mantenimientos (DEF-ADM-015 Fase 3).
      {
        path: 'maintenances',
        name: 'fleet-maintenances',
        component: MaintenanceStatus
      },
      {
        path: 'maintenances/history',
        name: 'fleet-maintenance-list',
        component: MaintenanceList
      },
      {
        path: 'maintenances/create',
        name: 'fleet-maintenance-create',
        component: MaintenanceEditor
      },
      {
        path: 'maintenances/:id/edit',
        name: 'fleet-maintenance-edit',
        component: MaintenanceEditor
      },
      {
        path: 'maintenances/config/:vehicleId',
        name: 'fleet-maintenance-config',
        component: MaintenanceConfig
      },
      // Contratos de alquiler (DEF-ADM-015 Fase 4).
      {
        path: 'rentals',
        name: 'fleet-rentals',
        component: RentalStatus
      },
      {
        path: 'rentals/:vehicleId/payments',
        name: 'fleet-rental-payments',
        component: RentalPaymentList
      },
      {
        path: 'rentals/:vehicleId/payments/create',
        name: 'fleet-rental-payment-create',
        component: RentalPaymentEditor
      },
      {
        path: 'rentals/payments/:id/edit',
        name: 'fleet-rental-payment-edit',
        component: RentalPaymentEditor
      }
    ]
  }
]

export default routes
